module.exports = __webpack_public_path__ + "static/media/RoomService_Meal1_Category2_Quantity1_ViewMeal.4e414409.png";